import { Company } from '../../../types/models/company/company.types';
import { ConsultationDevis } from '../../../types/models/consultations/consultationDevis.types';
import { CONSULTATIONS_ENDPOINTS } from '../../../utils/api/endpoints/consultationsEndpoints';

const PREFIX = '[consultationSummaryQuery]';

export const queryConsultationDevis = async (consultationId: number) => {
  console.log(PREFIX, `Fetching consultation #${consultationId}...`);
  const response = await CONSULTATIONS_ENDPOINTS.consultationDevis(consultationId);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received consultation #${consultationId}.`);
  return json as (ConsultationDevis & Company)[];
};
